/**
 * UseBackupActionType - Action permettant de restaurer une sauvegarde précédente
 * Identique à Flutter UseBackupActionType
 */

import {ActionType} from '../../types/ActionType';
import {GameState, GameStateStatus, GameStateType} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import {PlayerNotification} from '../../../models/PlayerNotification';
import gameStateService from '../../../services/gameStateService';

export class UseBackupActionType implements ActionType {
  typeName = 'use_backup';

  async execute(
    gameState: GameState,
    currentStep: PlayerStep,
    params?: {[key: string]: any},
  ): Promise<PlayerNotification[]> {
    console.log('[UseBackupActionType] Executing use_backup action');
    const notifications: PlayerNotification[] = [];

    // Vérifier que le gameState est en état FAILED
    if (gameState.state !== GameStateStatus.FAILED) {
      throw new Error("You haven't failed - backup forbidden");
    }

    // Vérifier qu'il y a un backup
    if (!gameState.hasBackup) {
      throw new Error('No backup for this game');
    }

    try {
      // Utiliser gameStateService pour récupérer le backup (gère mode test et normal)
      const backupState = await gameStateService.getBackup(gameState);

      if (!backupState) {
        throw new Error('Backup not found');
      }

      console.log('[UseBackupActionType] Backup found:');
      console.log(`[UseBackupActionType] - backup idApi: ${backupState.idApi}`);
      console.log(`[UseBackupActionType] - backup currentStepNumber: ${backupState.data.currentStepNumber}`);
      console.log(`[UseBackupActionType] - backup state: ${backupState.state}`);

      // Sauvegarder l'ID original du gameState
      const originalIdApi = gameState.idApi;
      const originalUserId = gameState.userId;
      const originalUniqueURI = gameState.uniqueURI;
      const originalSlot = gameState.slot;

      // Restaurer le backup : substituer les données du backup au gameState actuel
      // Copier toutes les propriétés du backup vers le gameState
      gameState.data = JSON.parse(JSON.stringify(backupState.data)); // Deep copy
      gameState.lastUpdate = backupState.lastUpdate;
      gameState.lastSync = backupState.lastSync;
      
      // Garder l'ID original (ne pas utiliser l'ID du backup)
      gameState.idApi = originalIdApi;
      gameState.userId = originalUserId;
      gameState.uniqueURI = originalUniqueURI;
      gameState.slot = originalSlot;
      
      // Remettre le type à normal
      gameState.type = GameStateType.NORMAL;
      // Remettre le state à playing
      gameState.state = GameStateStatus.PLAYING;
      // Garder la référence au backup (hasBackup reste true)
      gameState.hasBackup = true;
      gameState.dirty = true;

      console.log('[UseBackupActionType] Restored game state:');
      console.log(`[UseBackupActionType] - idApi: ${gameState.idApi}`);
      console.log(`[UseBackupActionType] - currentStepNumber: ${gameState.data.currentStepNumber}`);
      console.log(`[UseBackupActionType] - state: ${gameState.state}`);
      console.log('[UseBackupActionType] Backup restored successfully');
    } catch (error) {
      console.error('[UseBackupActionType] Failed to restore backup:', error);
      throw error;
    }

    return notifications;
  }
}
